(() => {
  'use strict';
  const host = document.querySelector('mcase-color-customizer');
  if (!host) return;
  const config = JSON.parse(host.querySelector('[data-mcase-config]').textContent);
  const commerce = window.MCaseCommerce.create(JSON.parse(host.querySelector('[data-mcase-catalog]').textContent), JSON.parse(host.querySelector('[data-mcase-commerce]').textContent));
  host.commerce = commerce;
  const caseParts = config.parts;
  const parts = [...caseParts, {
    id: 'chin-long', label: 'Extended Chin',
    default: caseParts.find(part => part.id === 'chin').default
  }];
  const colors = config.palette;
  const pricing = JSON.parse(document.querySelector('[data-parts-prices]').textContent);
  pricing.unitPrices['chin-long'] = pricing.unitPrices.chin;
  const money = cents => commerce.money(cents);
  for (const part of parts) {
    try { pricing.unitPrices[part.id] = commerce.variant(`${part.id}:black`).price; } catch { pricing.unitPrices[part.id] = commerce.storefront ? null : pricing.unitPrices[part.id]; }
  }
  try { pricing.unitPrices.magsafe = commerce.variant('magsafe:standard').price; } catch { pricing.unitPrices.magsafe = commerce.storefront ? null : pricing.unitPrices.magsafe; }
  const ringKey = 'magsafe:standard';
  const keyFor = (part, color) => `${part}:${color}`;
  const imageFor = (part, color) => commerce.images[`${part}:${color}`] || (part === 'magsafe' ? '/assets/parts/magsafe-ring.svg?v=white-1' : `/assets/parts/${part}-${color}.png`);
  const catalog = new Map(parts.flatMap(part => colors.map(color => [keyFor(part.id, color.id), { part, color }])));
  catalog.set(ringKey, {part:{id:'magsafe',label:'MagSafe Ring'},color:{id:'standard',label:'Extra ring'}});
  function subtotal(selection) {
    let amount = 0;
    for (const [key, quantity] of Object.entries(selection)) {
      let unit;
      try { unit = commerce.variant(key).price; } catch { return null; }
      const line = unit * quantity;
      if (!Number.isSafeInteger(unit) || unit < 0 || !Number.isSafeInteger(line) || !Number.isSafeInteger(amount + line)) return null;
      amount += line;
    }
    return amount;
  }
  const validQuantity = value => Number.isSafeInteger(Number(value)) && Number(value) >= 1;
  const storageKey = 'mcase-parts-library-v1:selection';
  let committed = {};
  try {
    if (host.freshDesign) sessionStorage.removeItem(storageKey);
    const saved = host.freshDesign ? {} : JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    if (saved && typeof saved === 'object') for (const [key, qty] of Object.entries(saved)) {
      if (catalog.has(key) && validQuantity(qty)) committed[key] = Number(qty);
    }
  } catch { /* Storage is optional; selections still work in this page. */ }
  let draft = {};
  const modalStates = new Map();
  const previewColors = Object.fromEntries(parts.map(part => [part.id, part.default]));
  let palettePart = null;
  let paletteSelection = new Set();
  let paletteMode = 'edit';
  let ringDetailQuantity = 1;
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
  const section = document.createElement('section');
  section.className = 'sm-parts';
  section.id = 'module-vault';
  section.setAttribute('aria-label', 'Extra modules');
  section.innerHTML = `<div class="sm-parts__heading"><h3>Extra modules</h3><span data-extras-count>Optional</span></div>
    <p class="sm-parts__intro">A new color. A spare part. More ways to make it yours.</p>
    <button class="sm-vault" type="button" data-parts-open aria-haspopup="dialog" aria-labelledby="mcase-vault-action">
      <span class="sm-vault__eyebrow" aria-hidden="true">${icon}<span>MODULE VAULT</span></span>
      <span class="sm-vault__grid" aria-hidden="true">${caseParts.map((part, index) => {
        const vaultColors = {frame:'black', camera:'blue', backplate:'green', buttons:'pink', chin:'red'};
        return `<span class="sm-vault__slot"><span class="sm-vault__visual"><span class="sm-vault__number">${String(index + 1).padStart(2, '0')}</span><span class="sm-vault__corner sm-vault__corner--top"></span><span class="sm-vault__corner sm-vault__corner--left"></span><span class="sm-vault__corner sm-vault__corner--right"></span><img src="${imageFor(part.id, vaultColors[part.id] || part.default)}" alt="" width="400" height="400" loading="lazy" decoding="async" draggable="false"></span><span class="sm-vault__name">${part.label}</span></span>`;
      }).join('')}</span>
      <span class="sm-vault__action"><span id="mcase-vault-action" data-vault-label>Open module vault</span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5 19 19 5M7 5h12v12" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg></span>
    </button>
    <ul class="sm-parts__selection" data-extras-list></ul>
    <div class="sm-parts__subtotal" data-selected-extras-summary hidden><span>Extras total</span><strong data-selected-extras-total>US$0.00</strong></div>`;
  host.querySelector('[data-selection-summary], [data-price-summary]').before(section);
  const priceRow = document.createElement('div');
  priceRow.hidden = true;
  priceRow.dataset.extrasPriceRow = '';
  priceRow.innerHTML = '<dt data-extras-price-label>Extra modules</dt><dd data-extras-subtotal>US$0.00</dd>';
  host.querySelector('.sm-mcase__price-total').before(priceRow);

  const dialog = document.createElement('dialog');
  dialog.className = 'sm-library';
  dialog.id = 'mcase-parts-library';
  dialog.setAttribute('aria-labelledby', 'parts-title');
  dialog.setAttribute('aria-describedby', 'parts-description');
  section.querySelector('[data-parts-open]').setAttribute('aria-controls', dialog.id);
  dialog.innerHTML = `<header class="sm-library__header"><div><p class="sm-library__eyebrow">MCASE / TITAN 2 ELITE</p><h2 id="parts-title">Modules library</h2><p id="parts-description"><span class="sm-library__desktop-copy">Choose colors. Set quantities.</span><span class="sm-library__mobile-copy">Tap + to add. Open Color to choose more colors.</span></p></div><button type="button" class="sm-library__close" data-parts-close aria-label="Close modules library">×</button></header>
    <div class="sm-library__scroll" tabindex="0" role="region" aria-label="Modules, quantities and colors">
      <div class="sm-mobile-list" data-mobile-list><div class="sm-mobile-list__head"><span>MODULE</span><span aria-hidden="true"></span><span>QTY</span><span>COLOR</span></div>${parts.map(part => `<div class="sm-mobile-list__group" data-mobile-group="${part.id}"></div>`).join('')}</div>
      <table class="sm-library__table"><caption class="visually-hidden">Rows are modules. Columns are colors. Select multiple tiles and adjust their quantities.</caption><thead><tr><th scope="col">MODULE / COLOR</th>${colors.map(color => `<th scope="col" id="parts-color-${color.id}"><span class="sm-library__color" style="--part-color:${color.hex}"></span>${color.label}</th>`).join('')}</tr></thead>
      <tbody>${parts.map((part, row) => `<tr><th scope="row" id="parts-row-${part.id}"><span class="sm-library__row-number">0${row + 1}</span><strong>${part.label}</strong><small>${money(pricing.unitPrices[part.id])}${part.id === 'buttons' ? ' / set' : ' / each'}</small>${part.id === 'backplate' ? '<small>No ring included</small>' : part.id === 'chin-long' ? '<small>Approx. 3 mm longer</small>' : ''}</th>${colors.map(color => {
        const key = keyFor(part.id, color.id);
        const label = `${color.label} ${part.label}`;
        return `<td headers="parts-row-${part.id} parts-color-${color.id}"><div class="sm-library__tile" data-tile="${key}"><button type="button" class="sm-library__select" data-select="${key}" aria-pressed="false" aria-label="${label}"><span class="sm-library__check" aria-hidden="true">✓</span><img src="${imageFor(part.id,color.id)}" alt="" width="400" height="400" draggable="false"></button><div class="sm-library__quantity" data-quantity-box="${key}" hidden><button type="button" data-decrease="${key}" aria-label="Decrease ${label} quantity">−</button><input type="number" inputmode="numeric" min="1" step="1" value="1" data-part-quantity="${key}" aria-label="${label} quantity"><button type="button" data-increase="${key}" aria-label="Increase ${label} quantity">+</button></div><span class="sm-library__tile-hint" data-tile-hint="${key}">Select</span></div></td>`;
      }).join('')}</tr>`).join('')}</tbody></table>
    </div>
    <footer class="sm-library__footer sm-library__actions"><button type="button" class="sm-ring-card" data-ring-option data-ring-info aria-label="Explore MagSafe Ring" aria-haspopup="dialog" aria-controls="mcase-ring-detail"><img src="${imageFor('magsafe','standard')}" alt="" width="48" height="48"><span class="sm-ring-card__copy"><strong>MagSafe Ring</strong><span>${money(pricing.unitPrices.magsafe)}</span></span><span class="sm-ring-card__added" data-ring-card-status hidden></span><span aria-hidden="true">↗</span></button>
    <div class="sm-library__summary"><strong data-library-total role="status" aria-live="polite">No extras selected</strong><div class="sm-library__subtotal"><span>Extras total</span><strong data-library-price aria-live="polite">US$0.00</strong></div></div><button type="button" class="sm-library__confirm" data-parts-confirm><span class="sm-library__confirm-desktop">Confirm selection</span><span class="sm-library__confirm-mobile">Confirm</span><span aria-hidden="true">→</span></button></footer>`;
  document.body.append(dialog);

  const cart = document.createElement('dialog');
  cart.className = 'sm-library sm-library--cart';
  cart.setAttribute('aria-labelledby', 'parts-cart-title');
  cart.innerHTML = `<header class="sm-library__header"><div><p class="sm-library__eyebrow">YOUR SELECTION</p><h2 id="parts-cart-title">Review your MCase</h2><p>Check your design and extras before adding to cart.</p></div><button type="button" class="sm-library__close" data-cart-close aria-label="Close MCase review">×</button></header><div class="sm-cart__content" data-cart-content></div><footer class="sm-library__footer sm-cart__footer"><div class="sm-cart__action sm-cart__action--confirm"><button type="button" class="sm-library__confirm" data-cart-confirm aria-describedby="parts-confirm-note">Confirm Add to Cart <span aria-hidden="true">→</span></button><p id="parts-confirm-note" class="sm-cart__action-note">Add this MCase and view your cart.</p></div><div class="sm-cart__action sm-cart__action--another"><button type="button" class="sm-library__confirm sm-cart__another" data-cart-another aria-describedby="parts-another-note">Add &amp; customize another</button><p id="parts-another-note" class="sm-cart__action-note">Add this MCase to your cart, then start a new design.</p></div><div class="sm-cart__status" data-cart-status role="status" aria-live="polite" tabindex="-1" hidden><span class="sm-cart__adding-icon-wrap" aria-hidden="true"><img class="sm-cart__adding-icon" src="${host.dataset.cartLoadingIcon || '/assets/smallsmore-preview-loading-hand.svg'}" alt="" width="1024" height="1024"></span><h2 class="sm-cart__adding-title" id="parts-cart-adding-title">Adding to cart</h2><p class="sm-cart__message" id="parts-cart-message" data-cart-message></p></div></footer>`;
  document.body.append(cart);

  const newDesignDialog = document.createElement('dialog');
  newDesignDialog.className = 'sm-library sm-library--new-design';
  newDesignDialog.setAttribute('aria-labelledby', 'parts-new-design-title');
  newDesignDialog.setAttribute('aria-describedby', 'parts-new-design-description');
  newDesignDialog.innerHTML = `<header class="sm-library__header"><div><p class="sm-library__eyebrow">ADDED TO YOUR CART</p><h2 id="parts-new-design-title" tabindex="-1" autofocus>Start your next MCase</h2></div><button type="button" class="sm-library__close" data-new-design-close aria-label="Close new MCase prompt">×</button></header><div class="sm-new-design__content"><p id="parts-new-design-description">Your previous MCase is in your cart. Choose new colors and details to make this one yours.</p></div><footer class="sm-library__footer sm-new-design__footer"><button type="button" class="sm-library__confirm" data-new-design-start>Start customizing <span aria-hidden="true">→</span></button></footer>`;
  document.body.append(newDesignDialog);

  const paletteDialog = document.createElement('dialog');
  paletteDialog.className = 'sm-library sm-color-dialog';
  paletteDialog.setAttribute('aria-labelledby', 'parts-color-title');
  paletteDialog.innerHTML = `<header class="sm-library__header"><div><p class="sm-library__eyebrow">CHOOSE YOUR COLORS</p><h2 id="parts-color-title">Module colors</h2><p>Select one or more. Each new color starts at 1.</p></div><button type="button" class="sm-library__close" data-color-close aria-label="Close color options">×</button></header><div class="sm-color-dialog__options" data-color-options></div><footer class="sm-library__footer"><span data-color-count>0 colors selected</span><button type="button" class="sm-library__confirm" data-colors-done>Done</button></footer>`;
  document.body.append(paletteDialog);

  const ringDialog = document.createElement('dialog');
  ringDialog.id = 'mcase-ring-detail';
  ringDialog.className = 'sm-library sm-ring-detail';
  ringDialog.setAttribute('aria-labelledby', 'parts-ring-title');
  ringDialog.innerHTML = `<header class="sm-library__header"><div><p class="sm-library__eyebrow">ONE RING. MORE POSSIBILITIES.</p><h2 id="parts-ring-title">MagSafe Ring</h2><p>${money(pricing.unitPrices.magsafe)} / each</p></div><button type="button" class="sm-library__close" data-ring-close aria-label="Close MagSafe Ring details">×</button></header>
    <div class="sm-ring-detail__content"><div class="sm-ring-detail__stage" role="img" aria-label="Rotating white magnetic ring"><div class="sm-ring-detail__shadow" aria-hidden="true"></div><div class="sm-ring-detail__model" aria-hidden="true">${Array.from({length:7},(_,layer)=>`<img src="${imageFor('magsafe','standard')}" alt="" style="--ring-depth:${layer-3}px" width="240" height="240">`).join('')}</div></div><div class="sm-ring-detail__intro"><h3>A spare for your next swap.</h3><p>Extra backplates come without a ring. Reuse the removable ring included with your complete MCase, or add a spare to make swapping easier.</p><button type="button" class="sm-ring-detail__remove" data-ring-remove hidden>Remove ring</button></div></div>
    <footer class="sm-library__footer sm-ring-detail__actions"><div class="sm-ring-detail__purchase"><label for="ring-detail-quantity">Quantity</label><div class="sm-ring-detail__quantity"><button type="button" data-ring-minus aria-label="Decrease ring quantity">−</button><input id="ring-detail-quantity" type="number" inputmode="numeric" min="1" step="1" value="1" data-ring-detail-quantity aria-label="Ring quantity"><button type="button" data-ring-plus aria-label="Increase ring quantity">+</button></div></div><div class="sm-library__subtotal"><span>Ring total</span><strong data-ring-detail-total>${money(pricing.unitPrices.magsafe)}</strong></div><button type="button" class="sm-library__confirm" data-ring-add>Add ring <span aria-hidden="true">→</span></button></footer>`;
  document.body.append(ringDialog);
  function renderRingDetail() {
    ringDialog.querySelector('[data-ring-detail-quantity]').value = String(ringDetailQuantity);
    ringDialog.querySelector('[data-ring-minus]').disabled = ringDetailQuantity <= 1;
    ringDialog.querySelector('[data-ring-plus]').disabled = ringDetailQuantity >= Number.MAX_SAFE_INTEGER;
    const amount = pricing.unitPrices.magsafe * ringDetailQuantity;
    ringDialog.querySelector('[data-ring-detail-total]').textContent = money(Number.isSafeInteger(amount) ? amount : null);
  }
  function openRingDetail() {
    ringDetailQuantity = draft[ringKey] || 1;
    renderRingDetail();
    ringDialog.querySelector('[data-ring-remove]').hidden = !draft[ringKey];
    ringDialog.querySelector('[data-ring-add]').innerHTML = `${draft[ringKey] ? 'Update ring' : 'Add ring'} <span aria-hidden="true">→</span>`;
    openModal(ringDialog);
    ringDialog.querySelector('.sm-ring-detail__content').scrollTop = 0;
  }
  ringDialog.addEventListener('click', event => {
    if (event.target.closest('[data-ring-close]')) return closeModal(ringDialog);
    if (event.target.closest('[data-ring-minus]')) { ringDetailQuantity = Math.max(1,ringDetailQuantity - 1); renderRingDetail(); }
    if (event.target.closest('[data-ring-plus]') && ringDetailQuantity < Number.MAX_SAFE_INTEGER) { ringDetailQuantity += 1; renderRingDetail(); }
    if (event.target.closest('[data-ring-add]')) {
      draft[ringKey] = ringDetailQuantity; renderTile(ringKey); renderDraftCount(); closeModal(ringDialog);
    }
    if (event.target.closest('[data-ring-remove]')) {
      delete draft[ringKey]; renderTile(ringKey); renderDraftCount(); closeModal(ringDialog);
    }
  });
  ringDialog.addEventListener('input', event => {
    if (!event.target.hasAttribute('data-ring-detail-quantity') || !validQuantity(event.target.value)) return;
    ringDetailQuantity = Number(event.target.value);
    const amount = pricing.unitPrices.magsafe * ringDetailQuantity;
    ringDialog.querySelector('[data-ring-detail-total]').textContent = money(Number.isSafeInteger(amount) ? amount : null);
    ringDialog.querySelector('[data-ring-minus]').disabled = ringDetailQuantity <= 1;
    ringDialog.querySelector('[data-ring-plus]').disabled = ringDetailQuantity >= Number.MAX_SAFE_INTEGER;
  });
  ringDialog.addEventListener('focusout', event => {
    if (event.target.hasAttribute('data-ring-detail-quantity')) renderRingDetail();
  });

  const count = selection => Object.values(selection).reduce((sum, qty) => sum + qty, 0);
  const orderedEntries = selection => [...catalog.keys()].filter(key => selection[key]).map(key => [key, selection[key]]);
  const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(committed)); } catch { /* optional */ } };
  function openModal(target) {
    modalStates.set(target, { focus:document.activeElement, overflow:document.body.style.overflow });
    document.body.style.overflow = 'hidden';
    target.showModal();
  }
  function closeModal(target) { if (target === cart && adding) return; target.close(); }
  for (const modal of [dialog, cart, paletteDialog, ringDialog, newDesignDialog]) {
    modal.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')]
        .filter(element => element.getClientRects().length && !element.closest('[hidden]'));
      if (!controls.length) { event.preventDefault(); return; }
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
        event.preventDefault(); first?.focus();
      }
    });
    modal.addEventListener('close', () => {
      const previous = modalStates.get(modal);
      document.body.style.overflow = previous?.overflow || '';
      if (previous?.focus?.isConnected) previous.focus.focus({ preventScroll:true });
      else if (modal === paletteDialog && dialog.open) dialog.querySelector(`[data-mobile-color="${palettePart}"]`)?.focus({preventScroll:true});
      modalStates.delete(modal);
    });
    modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const box = modal.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeModal(modal);
    });
  }
  newDesignDialog.addEventListener('click', event => {
    if (event.target.closest('[data-new-design-close]')) closeModal(newDesignDialog);
    if (event.target.closest('[data-new-design-start]')) newDesignDialog.close('start');
  });
  newDesignDialog.addEventListener('close', () => {
    if (newDesignDialog.returnValue !== 'start') return;
    const firstColor = host.querySelector('[data-picker-open]');
    firstColor?.scrollIntoView({ block: 'center' });
    firstColor?.focus({ preventScroll: true });
  });
  function renderMobilePart(partId) {
    const part = parts.find(item => item.id === partId);
    if (!part) return;
    const selected = colors.filter(color => draft[keyFor(partId,color.id)]);
    const rows = selected.length ? selected : [colors.find(color => color.id === previewColors[partId])];
    const group = dialog.querySelector(`[data-mobile-group="${partId}"]`);
    group.innerHTML = rows.map(color => {
      const key = keyFor(partId,color.id), qty = draft[key] || 0, label = `${color.label} ${part.label}`;
      return `<div class="sm-mobile-list__row${qty ? ' is-selected' : ''}" data-mobile-row="${key}"><div class="sm-mobile-list__name"><strong>${part.label}</strong><span>${money(pricing.unitPrices[partId])}${partId === 'buttons' ? ' / set' : ''}</span>${partId === 'backplate' ? '<small>No ring</small>' : partId === 'chin-long' ? '<small>Approx. 3 mm longer</small>' : ''}</div><img src="${imageFor(partId,color.id)}" alt="${label}" width="48" height="56"><div class="sm-mobile-list__quantity"><button type="button" data-mobile-minus="${key}" aria-label="Decrease ${label} quantity" ${qty ? '' : 'disabled'}>−</button><input type="number" min="0" step="1" inputmode="numeric" value="${qty}" data-mobile-quantity="${key}" aria-label="${label} quantity"><button type="button" data-mobile-plus="${key}" aria-label="Increase ${label} quantity">+</button></div><div class="sm-mobile-list__colors"><button type="button" class="sm-mobile-list__color" data-mobile-color="${partId}" data-mobile-current="${color.id}" aria-label="Choose ${part.label} colors" aria-haspopup="dialog"><span class="sm-mobile-list__dot" style="--part-color:${color.hex}"></span><span>${color.label}</span></button>${qty && selected.length < colors.length ? `<button type="button" class="sm-mobile-list__add-color" data-mobile-add-color="${partId}" aria-label="Add another ${part.label} color" title="Add another color" aria-haspopup="dialog">+</button>` : '<span></span>'}</div></div>`;
    }).join('');
  }
  function openColors(partId, mode = 'edit') {
    palettePart = partId;
    paletteMode = mode;
    paletteSelection = new Set(mode === 'add' ? [] : colors.filter(color => draft[keyFor(partId,color.id)]).map(color => color.id));
    const part = parts.find(item => item.id === partId);
    paletteDialog.querySelector('h2').textContent = `${mode === 'add' ? 'Add ' : ''}${part.label} colors`;
    paletteDialog.querySelector('.sm-library__header p:last-child').textContent = mode === 'add' ? 'Choose extra colors. Your existing quantities stay the same.' : 'Select one or more. Each new color starts at 1.';
    paletteDialog.querySelector('[data-color-options]').innerHTML = colors.map(color => {
      const alreadyAdded = mode === 'add' && Boolean(draft[keyFor(partId,color.id)]);
      return `<button type="button" class="sm-color-dialog__option" data-palette-color="${color.id}" aria-pressed="${alreadyAdded || paletteSelection.has(color.id)}" ${alreadyAdded ? 'disabled' : ''}><span class="sm-color-dialog__check" aria-hidden="true">✓</span><img src="${imageFor(partId,color.id)}" alt="" width="120" height="120"><span><i style="--part-color:${color.hex}"></i>${color.label}</span>${alreadyAdded ? '<small>Already added</small>' : ''}</button>`;
    }).join('');
    paletteDialog.querySelector('[data-color-count]').textContent = `${paletteSelection.size} colors selected`;
    openModal(paletteDialog);
  }
  paletteDialog.addEventListener('click', event => {
    if (event.target.closest('[data-color-close]')) return closeModal(paletteDialog);
    const colorButton = event.target.closest('[data-palette-color]');
    if (colorButton) {
      const color = colorButton.dataset.paletteColor;
      if (paletteSelection.has(color)) paletteSelection.delete(color); else paletteSelection.add(color);
      colorButton.setAttribute('aria-pressed', String(paletteSelection.has(color)));
      paletteDialog.querySelector('[data-color-count]').textContent = `${paletteSelection.size} colors selected`;
    }
    if (event.target.closest('[data-colors-done]')) {
      for (const color of colors) {
        const key = keyFor(palettePart,color.id);
        if (paletteSelection.has(color.id)) draft[key] ||= 1; else if (paletteMode === 'edit') delete draft[key];
        renderTile(key);
      }
      if (paletteSelection.size) previewColors[palettePart] = [...paletteSelection][0];
      renderMobilePart(palettePart); renderDraftCount(); closeModal(paletteDialog);
    }
  });
  function renderTile(key) {
    const qty = draft[key] || 0;
    if (key === ringKey) {
      const option = dialog.querySelector('[data-ring-option]');
      option.classList.toggle('is-selected', qty > 0);
      option.dataset.ringQuantity = String(qty);
      option.setAttribute('aria-label', `Explore MagSafe Ring${qty ? `, ${qty} selected` : ''}`);
      option.querySelector('[data-ring-card-status]').hidden = !qty;
      option.querySelector('[data-ring-card-status]').textContent = `× ${qty}`;
      return;
    }
    const tile = dialog.querySelector(`[data-tile="${key}"]`);
    tile.classList.toggle('is-selected', qty > 0);
    tile.querySelector('[data-select]').setAttribute('aria-pressed', String(qty > 0));
    tile.querySelector('[data-quantity-box]').hidden = !qty;
    tile.querySelector('[data-tile-hint]').hidden = Boolean(qty);
    tile.querySelector('[data-part-quantity]').value = String(qty || 1);
    tile.querySelector('[data-decrease]').disabled = qty <= 1;
    tile.querySelector('[data-increase]').disabled = qty >= Number.MAX_SAFE_INTEGER;
    renderMobilePart(catalog.get(key).part.id);
  }
  function renderDraftCount() {
    const total = count(draft), types = Object.keys(draft).length;
    dialog.querySelector('[data-library-total]').textContent = total ? `${total} extra${total === 1 ? '' : 's'} selected · ${types} option${types === 1 ? '' : 's'}` : 'No extras selected';
    dialog.querySelector('[data-library-price]').textContent = money(subtotal(draft));
  }
  function openLibrary() {
    draft = { ...committed };
    catalog.forEach((_, key) => renderTile(key));
    renderDraftCount();
    host.closeColorMenu?.(false);
    openModal(dialog);
    dialog.querySelector('.sm-library__scroll').scrollTop = 0;
  }
  function renderPrices() {
    try {
      const rates = commerce.casePrices(host.chinStyle || 'short');
      host.basePrice = rates.standard;
      host.config.pricing.textFee = rates.custom - rates.standard;
      host.currency = commerce.currency;
      host.querySelector('[data-case-subtotal]').textContent = money(host.basePrice * host.quantity);
      host.querySelector('[data-text-fee]').textContent = money(host.config.pricing.textFee * host.quantity);
      host.querySelector('[data-text-enabled]').parentElement.querySelector('strong').textContent = `+${money(host.config.pricing.textFee)} / case`;
      host.querySelector('.sm-mcase__price').textContent = money(host.textSelection.enabled ? rates.custom : rates.standard);
      host.querySelector('.sm-mcase__price').removeAttribute('aria-label');
      if (commerce.storefront) host.querySelector('.sm-mcase__inventory').textContent = commerce.variant(`case:${host.chinStyle || 'short'}:${host.textSelection.enabled ? 'custom' : 'standard'}`).available ? 'Available to order' : 'Ordering opens soon';
      host.querySelector('[data-total-price]').textContent = money(host.priceBreakdown().total);
    } catch {
      host.querySelector('[data-total-price]').textContent = 'Price pending';
    }
    const total = count(committed);
    const extras = subtotal(committed);
    priceRow.hidden = !total;
    priceRow.querySelector('[data-extras-price-label]').textContent = `Extras × ${total}`;
    priceRow.querySelector('[data-extras-subtotal]').textContent = money(extras);
    const summary = host.querySelector('[data-price-summary]');
    const totalLabel = summary.querySelector('.sm-mcase__price-total dt');
    totalLabel.textContent = total ? 'Order total' : 'Total';
    if (total) host.querySelector('[data-total-price]').textContent = money(extras === null ? null : host.priceBreakdown().total + extras);
  }
  function renderCommitted() {
    const list = section.querySelector('[data-extras-list]');
    list.replaceChildren();
    for (const [key, qty] of orderedEntries(committed)) {
      const { part, color } = catalog.get(key);
      const item = document.createElement('li');
      item.innerHTML = `<img src="${imageFor(part.id,color.id)}" alt="" width="52" height="52"><span><strong>${part.label}</strong><small>${color.label}</small></span><span class="sm-parts__selected-qty">× ${qty}</span><button type="button" data-remove-extra="${key}" aria-label="Remove ${color.label} ${part.label}">×</button>`;
      list.append(item);
    }
    const total = count(committed);
    section.querySelector('[data-extras-count]').textContent = total ? `${total} selected` : 'Optional';
    section.querySelector('[data-vault-label]').textContent = total ? 'Edit module vault' : 'Open module vault';
    section.querySelector('[data-selected-extras-summary]').hidden = !total;
    section.querySelector('[data-selected-extras-total]').textContent = money(subtotal(committed));
    host.renderPricing?.();
    renderPrices();
  }
  section.addEventListener('click', event => {
    if (event.target.closest('[data-parts-open]')) openLibrary();
    const remove = event.target.closest('[data-remove-extra]');
    if (remove) {
      delete committed[remove.dataset.removeExtra]; save(); renderCommitted();
      section.querySelector('[data-parts-open]').focus({ preventScroll: true });
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-ring-info]')) return openRingDetail();
    if (event.target.closest('[data-parts-close]')) return closeModal(dialog);
    if (event.target.closest('[data-parts-confirm]')) {
      committed = { ...draft }; save(); renderCommitted(); closeModal(dialog); return;
    }
    const mobileColor = event.target.closest('[data-mobile-color]');
    if (mobileColor) return openColors(mobileColor.dataset.mobileColor);
    const addColor = event.target.closest('[data-mobile-add-color]');
    if (addColor) return openColors(addColor.dataset.mobileAddColor, 'add');
    const mobilePlus = event.target.closest('[data-mobile-plus]');
    const mobileMinus = event.target.closest('[data-mobile-minus]');
    if (mobilePlus || mobileMinus) {
      const key = mobilePlus?.dataset.mobilePlus || mobileMinus.dataset.mobileMinus;
      const qty = draft[key] || 0;
      if (mobilePlus && qty < Number.MAX_SAFE_INTEGER) draft[key] = qty + 1;
      else if (mobileMinus && qty > 1) draft[key] = qty - 1;
      else if (mobileMinus) delete draft[key];
      previewColors[catalog.get(key).part.id] = catalog.get(key).color.id;
      renderTile(key); renderDraftCount();
      dialog.querySelector(`[${mobilePlus ? 'data-mobile-plus' : 'data-mobile-minus'}="${key}"]`)?.focus({preventScroll:true});
      return;
    }
    const select = event.target.closest('[data-select]');
    const increase = event.target.closest('[data-increase]');
    const decrease = event.target.closest('[data-decrease]');
    let key;
    if (select) {
      key = select.dataset.select;
      if (draft[key]) delete draft[key]; else draft[key] = 1;
    } else if (increase) { key = increase.dataset.increase; if (draft[key] < Number.MAX_SAFE_INTEGER) draft[key] += 1; }
    else if (decrease) { key = decrease.dataset.decrease; draft[key] = Math.max(1, draft[key] - 1); }
    if (key) { renderTile(key); renderDraftCount(); }
  });
  dialog.addEventListener('input', event => {
    const mobileKey = event.target.dataset.mobileQuantity;
    if (mobileKey) {
      const qty = Number(event.target.value);
      if (event.target.value && Number.isSafeInteger(qty) && qty >= 0) {
        if (qty) draft[mobileKey] = qty; else delete draft[mobileKey];
        event.target.closest('[data-mobile-row]').querySelector('[data-mobile-minus]').disabled = !qty;
        renderDraftCount();
      }
      return;
    }
    const key = event.target.dataset.partQuantity;
    if (!key || !draft[key]) return;
    if (validQuantity(event.target.value)) {
      draft[key] = Number(event.target.value);
      const tile = event.target.closest('[data-tile], [data-ring-option]');
      tile.querySelector('[data-decrease]').disabled = draft[key] <= 1;
      tile.querySelector('[data-increase]').disabled = draft[key] >= Number.MAX_SAFE_INTEGER;
      renderDraftCount();
    }
  });
  dialog.addEventListener('change', event => {
    if (event.target.dataset.mobileQuantity) {
      const key = event.target.dataset.mobileQuantity;
      previewColors[catalog.get(key).part.id] = catalog.get(key).color.id;
      renderTile(key); renderDraftCount();
    }
    if (event.target.dataset.partQuantity) renderTile(event.target.dataset.partQuantity);
  });
  dialog.addEventListener('focusout', event => {
    const key = event.target.dataset.mobileQuantity;
    if (!key) return;
    const value = Number(event.target.value);
    if (!event.target.value || !Number.isSafeInteger(value) || value < 0) {
      event.target.value = String(draft[key] || 0);
    }
  });
  host.addEventListener('mcase:price-change', renderPrices);

  const backPreviewCache = new Map();
  async function saveBackPreview(snapshot, preview) {
    const item = snapshot.case;
    const key = JSON.stringify({ colors: item.colors, chinStyle: item.chinStyle, mode: item.customizationMode, text: item.customText });
    if (backPreviewCache.has(key)) return backPreviewCache.get(key);
    const text = previewTextSelection(item);
    const png = await (preview || host.backPreviewPng(item.colors, text));
    if (!png) throw new Error('The back preview could not be saved.');
    const body = new FormData();
    body.append('design_file', png, 'mcase-back-preview.png');
    body.append('filename', 'mcase-back-preview.png');
    body.append('purpose', 'mcase-back-preview');
    const endpoint = host.dataset.previewUploadUrl || 'https://smallsmore-remove-bg-staging.vercel.app/api/design-upload';
    const response = await fetch(endpoint, { method: 'POST', body, signal: AbortSignal.timeout(12000) });
    const result = await response.json();
    const url = new URL(result.url);
    if (!response.ok || result.temporary !== false ||
        !String(result.pathname).startsWith('smallsmore-designs/mcase-previews/') ||
        url.protocol !== 'https:' || url.username || url.password) {
      throw new Error('The back preview could not be saved.');
    }
    backPreviewCache.set(key, url.href);
    return url.href;
  }

  let adding = false;
  let added = false;
  let pendingSelection = null;
  let pendingPreview = null;
  let previewUrl = null;
  const cartActions = [...cart.querySelectorAll('[data-cart-confirm], [data-cart-another]')];
  const cartStatus = cart.querySelector('[data-cart-status]');
  const cartMessage = cart.querySelector('[data-cart-message]');
  let cartBusyFocus = null;
  const clearBackPreview = () => {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    previewUrl = null;
  };
  function setCartBusy(busy) {
    const wasBusy = adding;
    if (busy && !wasBusy) cartBusyFocus = document.activeElement;
    adding = busy;
    cart.setAttribute('aria-busy', String(busy));
    cart.setAttribute('aria-labelledby', busy ? 'parts-cart-adding-title' : 'parts-cart-title');
    if (busy) cart.setAttribute('aria-describedby', 'parts-cart-message');
    else cart.removeAttribute('aria-describedby');
    add.disabled = busy;
    cartActions.forEach(button => { button.disabled = busy || added || !commerce.canOrder(pendingSelection); });
    cart.querySelectorAll('[data-cart-close]').forEach(button => { button.disabled = busy; });
    if (busy) cartStatus.focus({ preventScroll: true });
    else if (wasBusy && cartBusyFocus?.isConnected) cartBusyFocus.focus({ preventScroll: true });
  }
  cart.addEventListener('cancel', event => { if (adding) event.preventDefault(); });
  cart.addEventListener('close', () => {
    clearBackPreview();
    pendingSelection = null;
    pendingPreview = null;
  });
  const add = host.querySelector('.sm-mcase__submit');
  add.disabled = false;
  add.removeAttribute('title');
  add.setAttribute('aria-haspopup', 'dialog');
  host.querySelector('.sm-mcase__ordering-note').textContent = 'Review your design before adding it to cart.';
  function previewTextSelection(item) {
    return item.customText ? { ...item.customText, enabled: true, mode: 'text' }
      : { enabled: item.customizationMode === 'blank', mode: 'blank', text: '', color: config.text.defaultColor };
  }
  function cartSnapshot() {
    return {
      mode: commerce.storefront ? 'shopify' : 'local-preview',
      case: { model:'MCase for Titan 2 Elite', quantity:host.quantity, colors:{ ...host.selection }, chinStyle:host.chinStyle || 'short',
        customizationMode:host.textSelection.enabled ? host.textSelection.mode : 'default',
        customText:host.textSelection.enabled && host.textSelection.mode !== 'blank' ? {
          text:host.textSelection.text, color:host.textSelection.color,
          font:host.textSelection.font, size:host.textSelection.size,
          align:host.textSelection.align, outline:host.textSelection.outline,
          feePerCase:config.pricing.textFee
        } : null },
      accessories: orderedEntries(committed).map(([key, quantity]) => {
        const {part,color}=catalog.get(key); return {module:part.id, color:color.id, quantity, variantId:commerce.variant(key).id, unitPrice:commerce.variant(key).price};
      }),
      currency:'USD', caseSubtotal:host.priceBreakdown().total,
      extrasSubtotal:subtotal(committed),
      orderTotal:subtotal(committed) === null ? null : host.priceBreakdown().total + subtotal(committed)
    };
  }
  add.addEventListener('click', async () => {
    if (adding) return;
    if (host.textSelection.enabled && host.textSelection.mode !== 'blank' && !host.textSelection.text) {
      host.querySelector('[data-backplate-text-input]').focus();
      host.querySelector('[data-text-error]').hidden = false;
      return;
    }
    let snapshot, payload;
    try { snapshot = cartSnapshot(); payload = commerce.build(snapshot); } catch (error) { host.status(error.message); return; }
    added = false;
    clearBackPreview();
    pendingSelection = snapshot;
    cartStatus.hidden = true;
    cartMessage.textContent = '';
    snapshot.case.variantId = payload.items[0].id;
    snapshot.orderTotal = payload.total;
    const content = cart.querySelector('[data-cart-content]');
    content.replaceChildren();
    const caseLine = document.createElement('section');
    caseLine.className = 'sm-cart__case';
    caseLine.innerHTML = `<span class="sm-library__eyebrow">YOUR CASE</span><h3>MCase for Titan 2 Elite <span>× ${snapshot.case.quantity}</span></h3><ul>${caseParts.map(part => {
      const { color } = catalog.get(keyFor(part.id, snapshot.case.colors[part.id]));
      return `<li><span>${part.id === 'chin' && snapshot.case.chinStyle === 'long' ? 'Extended Chin' : part.label}</span><strong class="sm-cart__color"><span class="sm-cart__color-dot" style="--part-color:${color.hex}" aria-hidden="true"></span><span>${color.label}</span></strong></li>`;
    }).join('')}</ul>`;
    if (snapshot.case.customizationMode === 'blank') {
      const text = document.createElement('p');
      text.className = 'sm-cart__custom-text';
      text.textContent = `${host.customizationCopy.blankLabel}: ${host.customizationCopy.blankIntro}`;
      caseLine.append(text);
    }
    if (snapshot.case.customText) {
      const customText = snapshot.case.customText;
      const text = document.createElement('p');
      text.className = 'sm-cart__custom-text';
      text.textContent = `Custom text: ${customText.text}`;
      const styles = document.createElement('ul');
      styles.className = 'sm-cart__text-style';
      styles.setAttribute('aria-label', 'Custom text style');
      const details = [
        ['Text color', config.text.colors.find(color => color.id === customText.color)?.label],
        ['Font', config.text.fonts.find(font => font.id === customText.font)?.label],
        ['Font size', {s:'S', m:'M', l:'L'}[customText.size]],
        ['Alignment', {left:'Left', center:'Center', right:'Right'}[customText.align]],
        ['Outline', {none:'None', black:'Black', white:'White'}[customText.outline]]
      ];
      for (const [label, value] of details) {
        const row = document.createElement('li');
        const name = document.createElement('span');
        const selected = document.createElement('strong');
        name.textContent = label;
        selected.textContent = value || 'Not available';
        row.append(name, selected);
        styles.append(row);
      }
      caseLine.append(text, styles);
    }
    const preview = document.createElement('p');
    preview.textContent = 'Preparing your back preview…';
    caseLine.append(preview);
    content.append(caseLine);
    if (snapshot.accessories.length) {
      const title = document.createElement('h3'); title.textContent = `Selected extras · ${count(committed)} selected`; content.append(title);
      const list = section.querySelector('[data-extras-list]').cloneNode(true);
      list.removeAttribute('data-extras-list'); list.querySelectorAll('button').forEach(button => button.remove()); content.append(list);
    }
    const price = document.createElement('dl'); price.className='sm-cart__totals';
    const customizationLabel = snapshot.case.customizationMode === 'blank' ? host.customizationCopy.blankLabel : snapshot.case.customText ? host.customizationCopy.textLabel : '';
    const casePrice = document.createElement('div');
    const casePriceLabel = document.createElement('dt');
    casePriceLabel.textContent = `Case${customizationLabel ? ` + ${customizationLabel}` : ''}`;
    const casePriceValue = document.createElement('dd');
    casePriceValue.textContent = money(snapshot.caseSubtotal);
    casePrice.append(casePriceLabel, casePriceValue);
    price.innerHTML = `${snapshot.accessories.length ? `<div><dt>Extras total</dt><dd>${money(snapshot.extrasSubtotal)}</dd></div>` : ''}<div><dt>Total</dt><dd>${money(snapshot.orderTotal)}</dd></div>`;
    price.prepend(casePrice);
    content.append(price);
    cart.querySelector('header p:last-child').textContent = commerce.storefront
      ? 'Check your design and extras before adding to cart.'
      : 'Preview only. No items will be added to cart.';
    cart.dataset.selection = JSON.stringify(snapshot);
    setCartBusy(false);
    if (commerce.storefront && !commerce.canOrder(snapshot)) {
      cartMessage.textContent = 'Ordering opens soon. Your choices are saved.';
      cartStatus.hidden = false;
    }
    openModal(cart);
    const previewText = previewTextSelection(snapshot.case);
    // Keep the review image local. Only an explicit confirmation uploads it and adds the item.
    pendingPreview = host.backPreviewPng(snapshot.case.colors, previewText).then(png => {
      if (pendingSelection === snapshot && cart.open) {
        previewUrl = URL.createObjectURL(png);
        const link = document.createElement('a');
        link.href = previewUrl;
        link.target = '_blank'; link.rel = 'noopener';
        link.textContent = 'View your back preview';
        preview.replaceChildren(link);
      }
      return png;
    }).catch(() => {
      if (pendingSelection === snapshot && cart.open) preview.textContent = 'Your preview could not be prepared. Your colors and custom text are still included.';
      return null;
    });
  });
  function newDesignUrl() {
    const url = new URL(location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('mcase-') || key === 'parts') url.searchParams.delete(key);
    }
    url.hash = '';
    url.searchParams.set('mcase-new', '1');
    return url.href;
  }
  cart.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-close]')) return closeModal(cart);
    const button = event.target.closest('[data-cart-confirm], [data-cart-another]');
    const snapshot = pendingSelection;
    if (!button || adding || added || !snapshot || !commerce.canOrder(snapshot)) return;
    const another = button.hasAttribute('data-cart-another');
    cartStatus.hidden = false;
    cartMessage.textContent = 'Getting your MCase ready…';
    setCartBusy(true);
    try {
      try { snapshot.case.backPreviewUrl = await saveBackPreview(snapshot, pendingPreview); }
      catch { snapshot.case.backPreviewMissing = true; }
      cartMessage.textContent = 'Adding your MCase to cart…';
      await commerce.add(snapshot);
      added = true;
      cartMessage.textContent = snapshot.case.backPreviewMissing
        ? 'Added to cart. Your colors and custom text are saved, but the preview image could not be saved.'
        : 'Your MCase has been added to cart.';
      if (another) location.assign(newDesignUrl());
      else location.assign(commerce.routes.cart);
    } catch (error) {
      cartMessage.textContent = error.message;
      host.status(error.message);
    } finally {
      // Keep the transition visible until the next page loads after a successful add.
      if (!added) setCartBusy(false);
    }
  });
  renderCommitted();
  if (host.freshDesign) openModal(newDesignDialog);
  else if (new URL(location.href).searchParams.get('parts') === 'open') openLibrary();
})();
